import fileDownload from "js-file-download";
import ApiDefault from "../../ApiDefault";

export default function ApiControllingArea() {
    const apiDefault = ApiDefault("v2/accounting/controlling-area");

    // Query
    const query = async ({ page = 1, pageSize = 5, condition }) => {
        let urlCustom = `/${apiDefault.url}/query?page=${page}&limit=${pageSize}`;

        for (let field in condition) {
            if (condition[field] !== "") {
                urlCustom += `&${field}=${condition[field]}`;
            }
        }

        return await apiDefault.api
            .get(urlCustom)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const exportCostCenters = async (id, fileName) => {
        return await apiDefault.api
            .get(`/${apiDefault.url}/export-cost-centers/${id}`, { responseType: "blob" })
            .then((response) => {
                if (response.status !== 200) {
                    return {
                        status: false,
                        message: "Nenhum dado encontrado para exportação do arquivo.",
                    };
                }

                fileDownload(response.data, `${fileName}.xlsx`);

                return {
                    status: response.status === 200,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const importCostCenters = async (file) => {
        const form = new FormData();
        form.append("conta", file, "cost-centers.xlsx");

        return await apiDefault.api
            .post(`/${apiDefault.url}/import-cost-centers`, form, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    return {
        apiDefault,
        exportCostCenters,
        importCostCenters,
        query,
    };
}
